import React, { useState } from "react";
import { FaCheck } from "react-icons/fa6";
import Classes from "./styles/style.module.css";
import CustomButton from "../CustomButton";

import Pi1 from "../../images/profileImage/pi-set-1-0.png";
import Pi2 from "../../images/profileImage/pi-set-1-1.png";
import Pi3 from "../../images/profileImage/pi-set-1-2.png";
import Pi4 from "../../images/profileImage/pi-set-1-3.png";
import Pi5 from "../../images/profileImage/pi-set-1-4.png";
import Pi6 from "../../images/profileImage/pi-set-1-5.png";
import Pi7 from "../../images/profileImage/pi-set-1-6.png";
import Pi8 from "../../images/profileImage/pi-set-1-7.png";
import Pi9 from "../../images/profileImage/pi-set-1-8.png";
import Pi10 from "../../images/profileImage/pi-set-1-9.png";

const avatars = [
  {
    name: "pi-set-1-0",
    source: Pi1,
  },
  {
    name: "pi-set-1-1",
    source: Pi2,
  },
  {
    name: "pi-set-1-2",
    source: Pi3,
  },
  {
    name: "pi-set-1-3",
    source: Pi4,
  },
  {
    name: "pi-set-1-4",
    source: Pi5,
  },
  {
    name: "pi-set-1-5",
    source: Pi6,
  },
  {
    name: "pi-set-1-6",
    source: Pi7,
  },
  {
    name: "pi-set-1-7",
    source: Pi8,
  },
  {
    name: "pi-set-1-8",
    source: Pi9,
  },
  {
    name: "pi-set-1-9",
    source: Pi10,
  },
];

const AvatarSelector = ({ changeHandler }) => {
  const [selected, setSelected] = useState("");

  const handleSelect = (name) => {
    setSelected(name);
  };

  let renderAvatars = avatars.map((item, index) => {
    return (
      <div
        className={`${Classes.selectImageItem} col-4 text-center mb-2`}
        onClick={() => handleSelect(item.name)}
        key={index}
      >
        <img
          src={item.source}
          alt="item.name"
          className={Classes.selectImage}
        />
        {selected === item.name ? (
          <div className={Classes.checkedContainer}>
            <FaCheck color="#246BFD" />
          </div>
        ) : null}
      </div>
    );
  });

  return (
    <div className="row w-100 mx-0 px-0 justify-content-center">
      {renderAvatars}
      <div className="col-12 text-center mt-2">
        {selected ? (
          <CustomButton
            text={"عوضش کن"}
            clickHandler={() => changeHandler(selected)}
            color={"primary"}
            shadow
          />
        ) : null}
      </div>
    </div>
  );
};

export default AvatarSelector;
